export const OPPORTUNITY_OPEN_STAGES = [
  'Prospecting',
  'Qualification',
  'Enquiry Checklist',
  'Proposal',
  'Negotiation',
] as const;

export const OPPORTUNITY_CLOSED_STAGES = ['Won', 'Lost'] as const;

export const OPPORTUNITY_STAGES = [...OPPORTUNITY_OPEN_STAGES, ...OPPORTUNITY_CLOSED_STAGES] as const;

/** Map legacy Solution Design onto Enquiry Checklist for display and grouping. */
export function canonicalOpportunityStage(stage: string | null | undefined): string {
  const s = String(stage || '').trim();
  if (!s) return 'Prospecting';
  if (s.toLowerCase() === 'solution design') return 'Enquiry Checklist';
  return s;
}
